<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="small">
            <common-content-spacer height="large">
                <common-page-header
                    :heading="$t('modals.resend_invitation_email.heading', { name: userFullName })"
                    :isCenter="true"
                    contentSpacing="medium"
                ></common-page-header>

                <common-buttons>
                    <common-button
                        :label="$t('common.microcopy.false')"
                        :isProcessing="isProcessing"
                        type="secondary"
                        size="large-long"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        :label="$t('common.microcopy.true')"
                        :isProcessing="isProcessing"
                        type="primary"
                        size="large-long"
                        @click="resendInvitation"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import UsersAPI from 'api/UsersAPI'

    export default {
        props: {
            isOpen: { type: Boolean, required: true },
            user: { type: Object, required: true },
        },

        data() {
            return {
                isProcessing: false,
            }
        },

        computed: {
            userFullName() {
                return `${this.user.firstName} ${this.user.lastName}`
            },
        },

        methods: {
            resendInvitation() {
                this.isProcessing = true
                UsersAPI.resendPracticeInvitation(this.$auth.getActiveMember().id, this.user.token).then(() => {
                    this.emitEvent({ name: 'invitation-resent', payload: this.user })
                    this.isProcessing = false
                })
            },
        },
    }
</script>
